import type { CSSProperties } from 'react'

/** The small Starchive star turning a quarter at a time: the app's "working" mark, in place of the grey spinner.
 *  It takes the text colour of whatever it sits in (a CSS mask over the star PNG), so it is white on a black button
 *  and black on a white row. Under Reduce Motion it stands still. */
export function StarTick({ size = 18, style, className = '' }: { size?: number; style?: CSSProperties; className?: string }) {
  return <span className={'startick ' + className} style={{ width: size, height: size, ...style }} aria-hidden="true" />
}

/** A busy label for a CTA: the star tick and one word. `{busy ? <Working>Recording</Working> : 'Record sale'}` */
export function Working({ children }: { children: string }) {
  return <span className="working"><StarTick /><span>{children}</span></span>
}
